<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'거점 선택'"
      :modal="true"
      :width="'450px'"
      @open="onOpenWindow"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="pop-container">
      <div class="pop-conts">
        <div class="pwindow">
          <ul class="filter_list">
            <li>
              <label class="pd0">사업장<span class="forg">*</span></label>
              <ul class="w70">
                <li>
                  <kendo-dropdownlist
                      class="w100"
                      ref="facilityRef"
                      v-model="facility"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      :data-source="zone1DepthList"
                      @change="onChangeFacility(); area = null;"
                      :option-label="'사업장을 선택하세요.'"
                      value="0"
                  >
                  </kendo-dropdownlist>
                </li>
              </ul>
            </li>
            <li>
              <label class="pd0">거점<span class="forg">*</span></label>
              <ul class="w70">
                <li>
                  <kendo-dropdownlist
                      class="w100"
                      ref="areaRef"
                      v-model="area"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      @change="onChangeArea(); lockerId = null;"
                      :option-label="'거점을 선택하세요.'"
                      value="0"
                  >
                  </kendo-dropdownlist>
                </li>
              </ul>
            </li>
            <li>
              <label class="pd0">보관 위치<span class="forg">*</span></label>
              <ul class="w70">
                <li>
                  <kendo-dropdownlist
                      class="w100"
                      ref="lockerIdRef"
                      v-model="lockerId"
                      :data-text-field="'lockerNm'"
                      :data-value-field="'lockerId'"
                      :option-label="'거점 선택 후 선택해주세요.'"
                  >
                  </kendo-dropdownlist>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="button_area w60 mgt30">
          <ul>
            <li class="w25">
              <button class="large_btn" @click="onClickCloseWindow">취소</button>
            </li>
            <li class="w25">
              <button class="large_btn orange ml5" @click="onClickSaveData">저장</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </kendo-window>
</template>

<script>
import {ZoneMixin} from "@/mixin/Mixin";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "ZoneInfoWindow",
  mixins: [ZoneMixin],
  props: {
    propsSendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
  },
  methods: {
    onOpenWindow () {
      const vm = this
      vm.facility = vm.propsSendInfo.facility
      vm.area = vm.propsSendInfo.area
      vm.$refs.facilityRef.kendoWidget().value(vm.propsSendInfo.facility) // 사업장 세팅
      vm.onChangeFacility() // 거점 세팅
      vm.getLockerNmList(vm.area) // 보관위치 드롭다운 세팅
    },
    onChangeFacility () {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.areaRef.kendoWidget().value(vm.area)
    },
    onChangeArea () {
      const vm = this
      vm.area = vm.$refs.areaRef.kendoWidget().value()
      vm.getLockerNmList(vm.area)
    },
    getLockerNmList (area) {
      const vm = this
      if(EtnersCommonUtil.isEmpty(area)) {
        vm.lockerNmDataSource = []
        return
      }
      const param = {
        loginUserToken: vm.loginUserToken,
        area: area
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/lockerNmList.json`
      ApiUtil.post(jsonUrl, param, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData

        // 보관 위치 디폴트 세팅
        vm.lockerNmDataSource = resultData
        vm.$refs.lockerIdRef.kendoWidget().setDataSource(resultData)
        let lockerId = null
        if (resultData.length > 0) {
          lockerId = resultData[0].lockerId
        }
        vm.lockerId = lockerId
      })
    },
    onClickSaveData () {
      const vm = this

      if(!!!vm.facility) {
        kendo.alert('사업장을 선택하세요.')
        return false
      }
      if(!!!vm.area) {
        kendo.alert('거점을 선택하세요.')
        return false
      }
      if(!!!vm.lockerId) {
        kendo.alert('보관 위치를 선택하세요.')
        return false
      }

      const zoneInfo = {
        facility: vm.facility,
        area: vm.area,
        lockerId: vm.lockerId,
      }
      vm.$emit('getZoneInfo', zoneInfo)
    },
    onClickCloseWindow () {
      const refs = this.$refs
      refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      facility: null,
      area: null,
      lockerId: null,
      lockerNmDataSource: [],
    }
  }
}
</script>

<style scoped>

</style>